<template>
  <v-dialog v-model="dialog" max-width="400px" @click:outside="$emit('close')">
    <v-card>
      <v-card-title>Confirm</v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="error" @click="$emit('close')">
          {{ noText }}
        </v-btn>
        <v-btn text color="green" @click="$emit('click')">
          {{ yesText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ""
    },
    yesText: {
      type: String,
      default: "Yes"
    },
    noText: {
      type: String,
      default: "No"
    }
  },
  data() {
    return {
      dialog: true
    };
  }
};
</script>

<style></style>
